export default [
  {
    id: 'best3',
    title: 'BEST3',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'favorites',
    title: '好み',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'types',
    title: '何派',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'profile',
    title: 'プロフィール',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'address',
    title: '住所',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'contacts',
    title: '連絡先',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'edu-history',
    title: '学歴',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'job-history',
    title: '職歴',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'freespace',
    title: 'フリースペース',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'confirm',
    title: '確認',
    previewJumpId: 'confirm-preview'
  },
  {
    id: 'output',
    title: '完了',
    previewJumpId: 'close-preview-button-above'
  }
]
